module.exports = __webpack_public_path__ + "static/media/BudgetSmartIcon.9c03e57d.svg";